<template>
  <div class="px-24 py-10 text-gray-700 dark:text-gray-500 transition duration-500 ease-in-out">
      <h1 class="text-center font-light text-gray-500 text-3xl">Code Generator</h1>
      <div class="mt-10 flex justify-center min-w-full">
        <form @submit.prevent="generateCode">
          <div class="inline-block mt-2 w-1/2 pr-1">
            <label class="block text-sm text-gray-600" for="cus_email">Quantity</label>
            <input class="focus:outline-none focus:ring focus:border-teal-400 w-full px-5 py-1 text-gray-900 bg-white rounded border" v-model="quantity" id="quantity" name="quantity" type="number" required placeholder="Quantity..." >
          </div>
          <div class="inline-block mt-2 -mx-1 pl-1 w-1/2">
            <label class="block text-sm text-gray-600" for="cus_email">Value</label>
            <input class="focus:outline-none focus:ring focus:border-teal-400 w-full px-5 py-1 text-gray-900 bg-white rounded border" v-model="value" id="value"  name="value" type="number" required placeholder="Value..." >
          </div>
          <div class="block mt-2">
            <button type="submit" class="font-medium text-white bg-teal-400 px-2 py-1 text-md rounded hover:bg-white hover:text-teal-400">
              <p>Create</p>
            </button> 
          </div>
        </form>
      </div>
      <div class="mt-5 flex justify-center">
        <table class="min-w-max">
          <thead>
            <tr>
              <th
                class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
              >NUMRI</th>
              <th
                class="px-2 py-2 border w-3/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
              >CODE</th>
              <th
                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
              >VALUE</th>
              <th
                class="px-2 py-2 border w-9/12 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
              >DATE CREATED</th>
              <th
                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
              >USED</th>
              <th
                class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
              >COPY</th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-for="(d, index) in data" :key="d.id">
              <td
                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
              >{{ index + 1 }}</td>
              <td
                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
              >
              {{d.code}}
              </td>
              <td
                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
              >{{d.value}}€</td>
              <td
                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
              >
                {{d.created_at }}
              </td>
                <td
                class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
              >
                {{d.used }}
              </td>
              <td
                class="px-2 py-2 border text-md border-gray-400 leading-5 font-medium text-teal-400 text-center"
              >
                <button 
                    type="button"
                    v-clipboard:copy="d.code"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                  </svg>
                </button>
              </td>
              
            </tr>
          </tbody>
        </table>
        
      </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {

    data() {
        return {
            value: "",
            quantity: "",
            data: []
        }
    },
    created() 
	{
	this.getCodes();
	},
    methods: {

        generateCode () {
            axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("access_token");

            // var quantity = this.quantity;
                axios.post(`${process.env.VUE_APP_API}/create-codes`, 
                  {
                    value: this.value,
                    quantity: this.quantity
                  })
                  .then((res)=>{
                      console.log(res);
                      this.$toaster.success(res.data.message, {timeout: 3000, position: "top-left"});
                      this.getCodes();
                      this.value = '';
                      this.quantity = '';

                  }).catch((error) => console.log(error));

        },
        getCodes() {

            axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("access_token");

                axios.get(`${process.env.VUE_APP_API}/get-codes`)
                     .then((response) => {
                      //  console.log(response.data);
                       this.data = response.data;
                       if(response.data.trim() == 'back')
                       {
                         console.log('here');
                         this.$router.push('/*') 
                       }
				}).catch((error) => console.log(error));

        },
         onCopy: function (e) {
            // alert('Code copied: ' + e.text)
                        
            this.$toaster.success('CODE COPIED: ' + e.text, {timeout: 3000, position: "top-left"});

        },
        onError: function (e) {
            this.$toaster.error('Your toaster error message.')
            console.log(e);
        }
    }

}
</script>

<style>

</style>